<script setup>
import { userTypeLandings } from '@/router'
import { useAuthStore } from '@/stores/auth'
import { useRouter } from 'vue-router'

/**
 * PROBLEM:
 * Clicking the home icon on AuthHeader results in
 * the RouterView to display a blank page.
 * I tried everything to no avail.
 * 
 * SOLUTION:
 * Detect such scenario (refer to router/index.js)
 * and redirect to the apt Dashboard view and append
 * the query {refresh: true}
 */

const authStore = useAuthStore()
const router = useRouter()

if (!authStore.isLoggedIn) {
  router.push('/')
}

const applicationId = authStore.user.applicationId
router.push({
  name: userTypeLandings[applicationId],
  query: {
    refresh: true
  }
})
</script>

<style lang="scss" scoped></style>
